export const PURCHASE_BUTTON_INFO_START = 'PURCHASE_BUTTON_INFO_START';
export const PURCHASE_BUTTON_INFO_SUCCESS = 'PURCHASE_BUTTON_INFO_SUCCESS';
export const PURCHASE_BUTTON_INFO_ERROR = 'PURCHASE_BUTTON_INFO_ERROR';
export const PURCHASE_BUTTON_INFO_CLEAR = 'PURCHASE_BUTTON_INFO_CLEAR';

export const WORKFLOWSTART_START = 'WORKFLOWSTART_START';
export const WORKFLOWSTART_SUCCESS = 'WORKFLOWSTART_SUCCESS';
export const WORKFLOWSTART_ERROR = 'WORKFLOWSTART_ERROR';

export const WORKFLOWSTART_CLEAR = 'WORKFLOWSTART_CLEAR';

export const SET_WORKFLOWSTART_DATA = 'SET_WORKFLOWSTART_DATA';

export const PURCHASE_CONFIRMATION_START = 'PURCHASE_CONFIRMATION_START';
export const PURCHASE_CONFIRMATION_SUCESS = 'PURCHASE_CONFIRMATION_SUCESS';
export const PURCHASE_CONFIRMATION_ERROR = 'PURCHASE_CONFIRMATION_ERROR';
export const CLEAR_PURCHASE_CONFIRMATION = 'CLEAR_PURCHASE_CONFIRMATION';

export const GTRES_PURCHASE_START = 'GTRES_PURCHASE_START';
export const GTRES_PURCHASE_SUCCESS = 'GTRES_PURCHASE_SUCCESS';
export const GTRES_PURCHASE_ERROR = 'GTRES_PURCHASE_ERROR';

export const SET_CURRENT_PBI = 'SET_CURRENT_PBI';
export const CLEAR_CURRENT_PBI = 'CLEAR_CURRENT_PBI';

export const SET_CURRENT_WFS = 'SET_CURRENT_WFS';
export const CLEAR_CURRENT_WFS = 'CLEAR_CURRENT_WFS';

export const SET_CURRENT_PURCHASE_CONFIRMATION =
  'SET_CURRENT_PURCHASE_CONFIRMATION';
export const CLEAR_CURRENT_PURCHASE_CONFIRMATION =
  'CLEAR_CURRENT_PURCHASE_CONFIRMATION';
